import React from 'react'


const Button = props => {
	return <a
		className={`Button ${props.class}`}
		style={ props.styles }
		href={ props.link }
		download={ props.download }
		target={ props.newtab ? '_blank' : '_self' }
		rel='noopener noreferrer'
	>
		{ props.children }
	</a>
}

export default Button